import { lazy, Suspense } from 'react';
import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { muiTheme } from './muiTheme';
import { RouteLoadingState } from '../components/RouteLoadState';

const MarketingApp = lazy(() => import('../marketing/MarketingApp'));
const App = lazy(async () => {
  const { installDemoFetchMock } = await import('../demo/mockApi');
  installDemoFetchMock();
  return import('../App');
});

export default function ThemedEntry({ marketing }: { marketing: boolean }) {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={muiTheme}>
        <CssBaseline />
        <Suspense fallback={marketing ? null : <RouteLoadingState />}>{marketing ? <MarketingApp /> : <App />}</Suspense>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
